import { render, staticRenderFns } from "./ConferenceGallery.vue?vue&type=template&id=240f55a3&scoped=true"
import script from "./ConferenceGallery.vue?vue&type=script&lang=js"
export * from "./ConferenceGallery.vue?vue&type=script&lang=js"
import style0 from "./ConferenceGallery.vue?vue&type=style&index=0&id=240f55a3&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f55a3",
  null
  
)

export default component.exports